import type { RouteState } from './types';
import qs from 'qs';
import { STRINGIFY_OPTIONS } from './qsUtil';
import { useLocation, useNavigate } from 'react-router';
import useAfterMount from '@rio-cloud/rio-uikit/useAfterMount';

export const makeRoute = (searchParams: RouteState): string => {
    const queryParams = qs.stringify(searchParams, STRINGIFY_OPTIONS);
    const searchFragment = queryParams && `?${queryParams}`;
    return encodeURI(searchFragment);
};

const DISPLAY_OPTION_QUERY_KEYS = ['gridLines', 'compactRows'] as const;

export const mergeDriverDisplayOptionsIntoRoute = (route: string, currentSearch: string) => {
    const [pathname, routeSearch = ''] = route.split('?');
    const nextSearchParams = new URLSearchParams(routeSearch);
    const currentSearchParams = new URLSearchParams(currentSearch);

    DISPLAY_OPTION_QUERY_KEYS.forEach(key => {
        if (!nextSearchParams.has(key) && currentSearchParams.get(key) === 'true') {
            nextSearchParams.set(key, 'true');
        }
    });

    const mergedSearch = nextSearchParams.toString();
    return mergedSearch ? `${pathname}?${mergedSearch}` : pathname;
};

export const useUpdateRoute = (newSearch: string, enabled = true) => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    useAfterMount(() => {
        if (!enabled) {
            return;
        }

        const nextRoute = mergeDriverDisplayOptionsIntoRoute(newSearch, search);

        if (pathname + search !== nextRoute) {
            navigate(nextRoute);
        }
    }, [enabled, newSearch, pathname, search, navigate]);
};
